import React, { useState,useEffect } from 'react';
import Header from './navbar.js';
import {Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import '../css/resetPassword.css';
import { useDispatch , useSelector } from 'react-redux';
import { resetPassword } from '../store/Slices/authSlice.js';
import toast , {Toaster} from 'react-hot-toast';
import LoadingScreen from '../skeletons/loadingSkeleton.jsx';

const ResetPasswordAdmin = () => {
    const [email, setEmail] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.auth.loading);
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;

    useEffect(() => {
        if(sessionStorage.email !== adminEmail){
            navigate('/');
        }
    }, [  navigate]);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };
    
    const handleEmailBlur = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email) && email.length > 0) {
            setError('Invalid email format');
        } else {
            setError('');
        }
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if(e.target.value !== newPassword){
            setError('Passwords do not match');
        } else {
            setError('');
        }
    };

    const handleNewPasswordChange = (e) => {
        setNewPassword(e.target.value);
        if(e.target.value.length < 6){
            setError('New Password must be at least 6 characters long');
        } else {
            setError('');
        }
        if(confirmPassword !== e.target.value){
            setError('Passwords do not match');
        }
        else{
            setError('');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = {
            "email" : email, 
            "new_password" : newPassword
        };
        dispatch(resetPassword(data)).then((response) => {
            if(response?.payload?.message === "success"){
                toast.success('Password changed successfully');
            }
            else {
                setError(response?.error?.message || 'Something went wrong');
            }
        });
    };

    return (
        <div>
            <Header />
            <Toaster position="top-center" reverseOrder={false}></Toaster>
            
            {loading ? <LoadingScreen /> :
            
                <div className="login-container">
                    <div>
                    <h1 style={{paddingLeft:'10px' ,color:'#f16e00', fontWeight:'bold'}}>Reset Password</h1>
                    <br></br>
                </div>
                    <form onSubmit={handleSubmit} className="reset-password-box">
                        <div>
                            <label>Email:</label>   
                            <input 
                                type="email" 
                                value={email} 
                                onChange={handleEmailChange} 
                                onBlur={handleEmailBlur}
                                placeholder="Example@orange.com" 
                            />
                            {error && <span>{error}</span>}
                        </div>
                        <div>
                            <label>New Password:</label>
                            <input 
                                type="password" 
                                value={newPassword} 
                                onChange={handleNewPasswordChange} 
                                placeholder="New password" 
                            />
                        </div>
                        <div>
                            <label>Confirm Password</label>
                            <input
                                type="password"
                                placeholder="Confirm password"
                                onChange={handleConfirmPasswordChange}
                                value={confirmPassword}
                            />
                        </div>
                        <div className="login-link">
                            <Link to="/admin">Back to Home</Link>
                        </div>
                        <button type="submit" disabled = {error !== ''}>Reset Password</button>
                    </form>
                </div>
        }       
        </div>
    );
};

export default ResetPasswordAdmin;